import { useContext } from 'react'

import Link from '@atoms/Link'
import Logo from '@atoms/Logo'
import LanguageSwitch from '@molecules/LanguageSwitch'
import SnsIcon from '@icons/Sns'
import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'
import { Category } from '@models/Article'

import * as style from './style.module.sass'

const Footer = () => {
  const { t, locale } = useTranslation()
  const { action } = useContext(StoreContext)
  const { setShowContactModal } = action

  const categories: Category[] = [
    'business',
    'research',
    'philosophy',
    'culture',
    'beauty',
    'info',
  ]
  const specialCategories: Category[] = [
    'features',
    'series',
    'projects',
    'events',
  ]

  return (
    <div className={style.footer}>
      <div className={style.top}>
        <h2 className={style.logo}>
          <Link to="/">
            <Logo withText />
          </Link>
        </h2>

        <div className={style.categories}>
          <div className={style.label}>CATEGORIES</div>
          <div className={style.list}>
            {categories.map(category => (
              <Link className={style.item} key={category} to={`/${category}`}>
                {category.toUpperCase()}
              </Link>
            ))}
          </div>
        </div>

        <div className={style.special}>
          <div className={style.label}>SPECIAL CONTENT</div>
          <div className={style.list}>
            {specialCategories.map(category => (
              <Link className={style.item} key={category} to={`/${category}`}>
                {category.toUpperCase()}
              </Link>
            ))}
            <Link className={style.item} to="/artisan">
              ARTISAN
            </Link>
            <Link className={style.item} to="/about">
              ABOUT US
            </Link>
          </div>
        </div>

        <div className={style.bottomMenu}>
          <nav className={style.othersMenu}>
            <Link to="/about">
              <h3>ABOUT US</h3>
            </Link>
            <Link to="/privacy">
              <h3>PRIVACY POLICY</h3>
            </Link>
            <Link to="/terms">
              <h3>{locale === 'ja' ? '利用規約' : 'TERMS'}</h3>
            </Link>
            <Link to="/faq">
              <h3>FAQ</h3>
            </Link>
            <button onClick={() => setShowContactModal(true)}>
              <h3>{locale === 'ja' ? 'お問い合わせ' : 'CONTACT'}</h3>
            </button>
          </nav>

          <div className={style.sns}>
            <div className={style.label}>Follow Us</div>
            <nav className={style.icons}>
              <Link
                to={
                  locale === 'en'
                    ? 'https://twitter.com/zt_ftn_en'
                    : 'https://twitter.com/zt_ftn'
                }
                className={style.icon}
                data-name="x"
              >
                <SnsIcon name="x" />
              </Link>
              <Link
                to="https://www.instagram.com/fashiontechnews_official"
                className={style.icon}
                data-name="instagram"
              >
                <SnsIcon name="instagram" />
              </Link>
              <Link
                to="https://www.linkedin.com/showcase/fashion-tech-news"
                className={style.icon}
                data-name="linkedin"
              >
                <SnsIcon name="linkedin-skelton" />
              </Link>
              <Link
                to="https://ftn.zozo.com/"
                className={style.icon}
                data-name="note"
              >
                <SnsIcon name="note" />
              </Link>
            </nav>
          </div>
        </div>
      </div>

      <div className={style.copyright}>
        <div>
          ©️ZOZO NEXT, Inc. All Rights Reserved.
          <br />
          {t('footer.copyright')}
        </div>
        <LanguageSwitch />
      </div>
    </div>
  )
}

export default Footer
